import { render } from "./vue-countTo.vue?vue&type=template&id=5cb9f5ff"
import script from "./vue-countTo.vue?vue&type=script&lang=js"
export * from "./vue-countTo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__